export const PORTAL_LOGIN_BANNER = '#portal-login-banner';
